import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { medicineApi } from "apis";
import { GetMedicinesResponseDto } from "libs/cellera-sdk";

export const useGetMedicines = (params: {
  page?: number;
  pageSize?: number;
  search?: string;
}) => {
  return useQuery<GetMedicinesResponseDto>({
    queryKey: ["medicines", params],
    queryFn: () => medicineApi.getMedicines(params),
    placeholderData: keepPreviousData,
  });
};
